import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { HandBookContainerConverter, MACS_HANDBOOK_CONTAINER_CONVERTER_TOKEN } from './macs-handbook-container.component.converter'
import {
  HANDBOOK_FIRST_LEVEL_CONVERTER_TOKEN, HandBookFirstLevelConverter
} from '../handbook-first-level/handbook-first-level.component.converter'
import {
  HANDBOOK_SECOND_LEVEL_CONVERTER_TOKEN, HandBookSecondLevelConverter
} from '../handbook-second-level/handbook-second-level.component.converter'
import {
  HANDBOOK_THIRD_LEVEL_CONVERTER_TOKEN, HandBookThirdLevelConverter
} from '../handbook-third-level/handbook-third-level.component.converter'
import { STICKY_NAVIGATION_CONVERTER_TOKEN, StickyNavigationConverter } from '../sticky-navigation/sticky-navigation.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        macsHandbookContainerFeature: {
          module: () => import('./macs-handbook-container.module').then((m) => m.MacsHandbookContainerModule),
          cmsComponents: ['macs_handbooks'],
        },
      }
    }),
    {
      provide: MACS_HANDBOOK_CONTAINER_CONVERTER_TOKEN,
      useExisting: HandBookContainerConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        macs_handbooks: MACS_HANDBOOK_CONTAINER_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: HANDBOOK_FIRST_LEVEL_CONVERTER_TOKEN,
      useExisting: HandBookFirstLevelConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        handbook_first_level: HANDBOOK_FIRST_LEVEL_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: HANDBOOK_SECOND_LEVEL_CONVERTER_TOKEN,
      useExisting: HandBookSecondLevelConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        handbook_second_level: HANDBOOK_SECOND_LEVEL_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: HANDBOOK_THIRD_LEVEL_CONVERTER_TOKEN,
      useExisting: HandBookThirdLevelConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        handbook_third_level: HANDBOOK_THIRD_LEVEL_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: STICKY_NAVIGATION_CONVERTER_TOKEN,
      useExisting: StickyNavigationConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        macs_handbook_sticky_navigation: STICKY_NAVIGATION_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class MacsHandbookContainerFeatureModule {}
